import React, { useEffect, useState } from 'react';
import { Input } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { ContractNegotiationVersion } from '../../../models/Entities/Contracts/ContractNegotiationVersion';
import { NewContractNegotiationVersion } from '../../../models/Entities/Contracts/NewContractNegotiationVersion';
import { GuideDrawer, GuideDrawerForm } from '../../../theme/components/GuideDrawer';
import { GuideField } from '../../../theme/components/GuideField';

interface Props {
  contractNegotiationId: string;
  contractId: number;
  version?: ContractNegotiationVersion;
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (entity: NewContractNegotiationVersion | ContractNegotiationVersion) => void;
}

const toDateInputValue = (date: Date | undefined | null): string => {
  if (!date) return '';
  const d = new Date(date as Date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

const ContractNegotiationVersionFormComponent = (props: Props) => {
  const { t } = useTranslation();

  const [negotiationDate, setNegotiationDate] = useState<string>('');

  useEffect(() => {
    if (props.isOpen) {
      setNegotiationDate(toDateInputValue(props.version?.negotiationDate));
    }
  }, [props.isOpen, props.version]);

  const handleSave = () => {
    const base: NewContractNegotiationVersion = {
      contractNegotiationId: props.contractNegotiationId,
      negotiationDate: negotiationDate ? new Date(negotiationDate) : undefined,
    };

    if (props.version?.id) {
      props.onSave({ ...props.version, ...base });
    } else {
      props.onSave(base);
    }
  };

  const isEdit = !!props.version?.id;
  const dialogTitle = isEdit
    ? t('contractNegotiationVersionForm.titleEdit', 'Editar versión de negociación')
    : t('contractNegotiationVersionForm.titleNew', 'Nueva versión de negociación');

  return (
    <GuideDrawer
      open={props.isOpen}
      size="small"
      title={dialogTitle}
      onDismiss={props.onDismiss}
      testId="contract-negotiation-version-drawer"
      secondaryAction={{ label: t('contractNegotiationVersionForm.actions.cancel', 'Cancelar') }}
      primaryAction={{
        label: t('contractNegotiationVersionForm.actions.save', 'Guardar'),
        onClick: handleSave,
      }}
    >
      <GuideDrawerForm onSubmit={handleSave} testId="contract-negotiation-version-form">
        <GuideField label={t('contractNegotiationVersionForm.fields.negotiationDate', 'Fecha de negociación')}>
          <Input
            type="date"
            value={negotiationDate}
            onChange={(_, data) => setNegotiationDate(data.value)}
          />
        </GuideField>
      </GuideDrawerForm>
    </GuideDrawer>
  );
};

export default ContractNegotiationVersionFormComponent;
